import React from 'react';
import {
  BooleanInput,
  Create,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
  required,
} from 'react-admin';
import { Alert } from '@mui/material';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';

const CreateInchargeStation = (props) => (
  <Permission permission={PERMISSIONS.UPDATE_STATION}>
    <Create {...props} title="Cadastrar carregador elétrico" redirect="list">
      <SimpleForm sx={{ maxWidth: 620 }}>
        <Alert severity="info" sx={{ mb: 2 }}>
          O código é o que aparece no fim da URL do QR do carregador. Em
          <strong> https://pay.incharge.app/now/SD010</strong>, o código é <strong>SD010</strong>.
          Sem este cadastro o cliente até consegue carregar, mas não pontua.
        </Alert>

        <TextInput
          source="code"
          label="Código do QR"
          validate={[required()]}
          helperText="Só letras, números e hífen. Não pode repetir."
          sx={{ minWidth: 300 }}
        />

        <ReferenceInput source="placeId" reference="stations" perPage={200} sort={{ field: 'name', order: 'ASC' }}>
          <SelectInput
            label="Posto"
            optionText="name"
            validate={[required()]}
            helperText="O posto define quantos pontos o cliente ganha por kWh."
            sx={{ minWidth: 300 }}
          />
        </ReferenceInput>

        <TextInput
          source="name"
          label="Identificação (opcional)"
          helperText='Só para você se achar na lista. Ex.: "Carregador 1 - entrada".'
          sx={{ minWidth: 300 }}
        />

        <BooleanInput source="isActive" label="Ativo" defaultValue={true} />
      </SimpleForm>
    </Create>
  </Permission>
);

export default CreateInchargeStation;
